import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '@services/app.service';
import { CollectionService } from '@services/collection.service';
import { ShareDataService } from '@services/share-data.service';
import { Subject, Subscription } from 'rxjs';
import { AddCollectionComponent } from '../add-collection/add-collection.component';
import { RoleManagementService } from '@services/role.management.service';
import { NotificationService } from '@services/notification.service';
import { AccountAdminRole } from '@configs/role.config';
import { WebErrorService } from '@services/webError.service';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { videoAssetGroups } from '@configs/videoTitles';

export interface CollectionData {
  collectionName: string;
  langid: number;
  modifiedDateTime: string;
  language: string;
  description: string;
  timezone: string;
}

@Component({
  selector: 'app-collectionhome',
  templateUrl: './collectionhome.component.html',
  styleUrls: ['./collectionhome.component.scss'],
})
export class CollectionhomeComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  @ViewChild(MatSort) sort: MatSort;

  updatedCollectionData = [];
  langData: any;
  collectionData$: Subscription | undefined;
  collectionFilterSubscription$: Subscription | undefined;
  displayedColumns: string[] = ['collectionName',
    'language',
    'timezone',
    'modifiedDate',
    // 'action'
  ];
  dataSource: MatTableDataSource<CollectionData>;
  collectionid: any;
  selectedCollectionName: any;
  collectionIdToNavigate: any;
  filterValue: any;
  globalcollectionid: any;
  searchValue: any;
  collectionData: any
  isNoCollections = true;
  isFilterData = false;
  displayPaginations = false;
  private unsubscribe: Subject<void> = new Subject<void>();
  isHidden = false;
  videoLinks: any;
  videoAssetGroups = videoAssetGroups;
  hoverVideoApiCall: boolean = false;
  constructor(
    private router: Router,
    private collectionService: CollectionService,
    private routerstate: ActivatedRoute,
    private appService: AppService,
    private roleServ: RoleManagementService,
    private shareDataService: ShareDataService,
    public dialog: MatDialog,
    private notificationService: NotificationService,
    public roleSer: RoleManagementService,
    private webErrorService: WebErrorService,
    public translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.collectionData$ = this.collectionService.getNewCollectionData.subscribe(resData => {
        if (resData?.data.length === 0) {
          this.isNoCollections = true;
          this.dataSource.paginator = this.paginator;
        }
        else {
          this.dataSource = new MatTableDataSource(resData?.data);
          this.dataSource.sort = this.sort;
          this.isNoCollections = true;
        }
    }, (error: any) => { this.webErrorService.handleAPIErrors(error); });

    this.appService.changeUserHeader(1);
    this.langData = this.collectionService.getLanguages()?.subscribe((data) => {
      this.shareDataService.getLanguage(data?.items);
    }, (error: any) => { this.webErrorService.handleAPIErrors(error); });


    // Collection list start from here
    this.getCollection()
  }

  ngAfterViewInit(): void {
    document.onclick = (args: any) : void => {
      if(args.target.className != 'trainingIcon') {
        this.isHidden = false;
      }
    }
  }

  onTraningIcon(assetGroup) {
    this.isHidden = true;
    if (!this.hoverVideoApiCall) {
      this.collectionService.videoTutorial(assetGroup).subscribe(video => {
        this.videoLinks = video.data;
        this.hoverVideoApiCall = true;
      });
    }
  }

  open_in_new_window(features, link) {
    var new_window;
    if(features !== undefined && features !== '') {
      new_window = window.open('', '_blank', features);
    }
    else {
      new_window = window.open('', '_blank');
    }

    let video = '<video controls controlsList="nodownload" style="width: 100%; height: 100vh;"><source src="' + link + '" type="video/mp4" /></video>'

    if(link !== null && link !== '') {
      new_window.document.write('<!doctype html><html><head><title>Video Player</title><meta charset="UTF-8" /></head><body style="padding: 0; margin: 0;" oncontextmenu="return false">' + video + '</body></html>');
    }
  }

  getCollection(){
    this.collectionData$ = this.collectionService
      .getCollection()?.subscribe((resData: any) => {
          this.collectionData = resData?.data;
          if (this.collectionData.length === 0) {
            this.isNoCollections = true;
          }
          else {

            setTimeout(() => {
              this.dataSource = new MatTableDataSource(resData?.data);
               this.dataSource.sort = this.sort;
              this.dataSource.paginator = this.paginator;
              if(this.dataSource.paginator) {
                // ------Set translation for pagination------
                this.translate.stream([
                  'collections.pagination.pageLabel',
                  'collections.pagination.firstPage',
                  'collections.pagination.lastPage',
                  'collections.pagination.nextPage',
                  'collections.pagination.prevPage'
                ]).pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
                    this.dataSource.paginator._intl.itemsPerPageLabel = translation['collections.pagination.pageLabel'];
                    this.dataSource.paginator._intl.firstPageLabel = translation['collections.pagination.firstPage'];
                    this.dataSource.paginator._intl.lastPageLabel = translation['collections.pagination.lastPage'];
                    this.dataSource.paginator._intl.nextPageLabel = translation['collections.pagination.nextPage'];
                    this.dataSource.paginator._intl.previousPageLabel = translation['collections.pagination.prevPage'];

                    this.dataSource.paginator._intl.changes.next();
                });
              }
            });
            this.isNoCollections = false;
          }
      }, (error) => {
        this.router.navigate(['/login']);
      }) || undefined;
  }

  applyFilter(inputValue: any): any {
    // this.dataSource.filterPredicate = function(data, filter: string): boolean {
    //   data.description = data.description == null ? '' : data.description;
    //   data.timezone = data.timezone == null ? '' : data.timezone;
    //   return data.collectionName.toLowerCase().includes(filter) || data.language.toLowerCase().includes(filter) ||
    //   data.timezone.toLowerCase().includes(filter) || data.description.toLowerCase().includes(filter)
    // };

    // this.filterValue = inputValue;
    // this.dataSource.filter = this.filterValue.trim().toLowerCase();
    // if (this.dataSource.filteredData.length > 0) {
    //   this.isFilterData = false;
    // } else {
    //   this.isFilterData = true;
    // }

    // if (this.dataSource.paginator) {
    //   this.dataSource.paginator.firstPage();
    // }

    const filterObj = { searchText: inputValue}
    if(this.collectionFilterSubscription$){this.collectionFilterSubscription$.unsubscribe();}
    this.collectionFilterSubscription$ = this.collectionService.getCollectionFilter(filterObj)?.subscribe(
      (resData: any) => {
        this.collectionData = resData?.data;
        if (!this.collectionData || !this.collectionData.length) {
          this.isFilterData = true;
        }
        else {
          this.dataSource = new MatTableDataSource(resData?.data);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;

          this.isFilterData = false;
        };
      }, (error) => {
        this.isFilterData = true;
        this.dataSource.paginator = this.paginator;
        this.webErrorService.handleAPIErrors(error, null, true, 'warn');
      }, () => { }) || undefined;
  }

  isNumber(n): any { return /^-?[\d.]+(?:e-?\d+)?$/.test(n); }

  openNewCollectionDialog(): void {
    const dialogConfig: MatDialogConfig<AddCollectionComponent> = {
      minWidth: '650px',
    };
    const dialogRef = this.dialog.open(AddCollectionComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.isFilterData = false;
      this.searchValue = '';
      this.getCollection()
    });
  }

  createCollection(): void {
    this.router.navigate(["/collections/add"]);
  }

  resetFilter(): void {
    this.isFilterData = false;
    this.searchValue = '';
    this.getCollection()

  }

  collectioDetails(selectedCollection: any): void {
    if (selectedCollection) {
      this.selectedCollectionName = selectedCollection?.collectionName;
      this.collectionIdToNavigate = selectedCollection?.collectionuuId;
      this.roleServ.getUserRole(+selectedCollection?.collectionid).subscribe(data => {
        const permission = data.data.userrole.filter(d => d.rolesAssigned === AccountAdminRole.accountAdmin);
        if (permission && permission.length) {
          this.shareDataService.editCollection(selectedCollection);
          this.shareDataService.setGlobalCollectionId(selectedCollection?.collectionid);
          this.shareDataService.setGlobalCollectionuuId(selectedCollection?.collectionuuId);
          this.appService.selectedCollectionName.next(true);
          this.router.navigate(['/collections', selectedCollection?.collectionuuId]);
        }
        else {
          this.webErrorService.customErrors('Permission not found...!', true, 'warn')
        }
      }, (error: any) => { this.webErrorService.handleAPIErrors(error); });
    }
  }

  ngOnDestroy(): void {
    this.collectionData$.unsubscribe();
    if(this.collectionFilterSubscription$){this.collectionFilterSubscription$.unsubscribe();}
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
